export const CHROME_BROWSER = 'chrome';
export const SAFARI_BROWSER = 'safari';
export const FIREFOX_BROWSER = 'firefox';
export const EDGE_BROWSER = 'edge';
export const UNKNOWN_BROWSER = 'unknown';
